// ### Functions are for locking scroll on body element
// It's useful especially when popup is active and we want to scroll in it
// Body is fixed in place (not only overflow: hidden), so even programmatic scroll
// (e.g. select menu scrolling itself into view) can't move the page

let isLocked = false;

const lockedStyles = ['overflow', 'position', 'top', 'left', 'right', 'width'];

// We can pass a position where we want to scroll after enabling body scroll
export const unlockScroll = (yPos?: number) => {
    if (isLocked) {
        lockedStyles.forEach((property) => document.body.style.removeProperty(property));
        isLocked = false;
    }

    window.scrollTo({ top: yPos || 0, left: 0, behavior: 'instant' as ScrollBehavior });
};

// We can set a position when locking
export const lockScroll = (setYPos?: (y: number) => void) => {
    if (isLocked) {
        return;
    }

    const yOffset = window.pageYOffset;

    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${yOffset}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    isLocked = true;

    if (setYPos && yOffset > 0) {
        setYPos(yOffset);
    }
};
